export const GENERATED_LEAD_REPORT_LIST =
  "ROLE_GeneratedLeadReportView_collection_get";
export const GENERATED_LEAD_REPORT_CREATE =
  "ROLE_GeneratedLeadReportView_collection_post";
export const GENERATED_LEAD_REPORT_SHOW =
  "ROLE_GeneratedLeadReportView_item_get";
export const GENERATED_LEAD_REPORT_EDIT = "ROLE_BlacklistDevice_item_put";
export const GENERATED_LEAD_REPORT_DELETE = "ROLE_BlacklistDevice_item_delete";
